import { UsersListLoading } from "../../Reviews/Review/users-list/components/loading/UsersListLoading";
import { KTCardBody, KTIcon } from "../../../../_metronic/helpers";
import { Pagination } from "../../../../components/Pagination";
import { formatPrice } from "../../../../_metronic/helpers/utils";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import opacity from "react-element-popper/animations/opacity";
import axios from "axios";
import FileDownload from 'js-file-download';

const headers = [
  { title: 'Customer Name', width: '180px' },
  { title: 'Member Number', width: '150px' },
  { title: 'Reservation Number', width: '180px' },
  { title: 'Earning Date', width: '180px' },
  { title: 'Booking Amount', width: '150px' },
  { title: 'Club Cash Earned', width: '150px' },
]



export const ClubCashInfoTable = ({ clubCashData, isLoading, setLoading, page, setPage, pageSize, setPageSize, searchType, setSearchType, search, setSearch, startDate, setStartDate, endDate, setEndDate }) => {

const handleExport = async () => {
 setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_V3_URL}/wallets/club-cash?is_download=true`,
        { responseType: 'blob' }
      );
      const disposition = response.headers['content-disposition'];
      let filename = 'club_cash.csv';
      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileDownload(blob, filename);
      toast.success('Club cash file downloaded successfully');
      setLoading(false);
    } catch (error) {
      toast.error('Error downloading file');
      setLoading(false);
    }
}

  return (
    <KTCardBody className='py-4'>
      <div className="d-flex align-items-center position-relative my-1 search-wrapper justify-content-between">
        <div className="d-flex gap-2">
        <select
          className="form-select form-select-solid fw-bolder w-200px"
          data-kt-select2="true"
          data-placeholder="Select option"
          data-allow-clear="true"
          data-kt-user-table-filter="two-step"
          data-hide-search="true"
          value={searchType}
          onChange={(e) => {
            setSearch("")
            setStartDate(null)
            setEndDate(null)
            setSearchType(e.target.value)
          }}
        >
          <option value="trucker_id" selected>
            Member Number
          </option>
          <option value="trucker_name">
            Customer Name
          </option>
          <option value="reservation_code">
            Reseravation Number
          </option>
           <option value="date">
            Earning Date
          </option>
        </select>
        {searchType && searchType !== 'date' ?
          <div className="d-flex align-items-center position-relative my-1">
            <KTIcon
              iconName="magnifier"
              className="fs-1 position-absolute ms-6"
            />
              <input
              type="text"
              data-kt-user-table-filter="search"
              className="form-control form-control-solid w-300px ps-14"
              placeholder={`Search by ${searchType === "trucker_id" ? "Member Number" :
                searchType === "trucker_name" ? "Customer Name" :
                "Reservation Number"
                }`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        : 
            <>
              <div>
                <DatePicker
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    borderRadius: "8px",
                    padding: "0.775rem 1rem",
                    fontSize: "1.1rem",
                    fontWeight: "500",
                    lineHeight: "1.5",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #f9f9f9",
                    color: "#5e6278",
                    transition: "color 0.2s ease",
                    height: "auto"
                  }}
                  containerStyle={{
                    width: "100%"
                  }}
                  className="rmdp-mobile custom-calendar"
                  arrow={false}
                  value={startDate}
                  onChange={(val) => {
                    setStartDate(val);
                  }}
                  maxDate={dayjs(endDate).toDate()}
                  format="dddd MMM DD,YYYY"
                  fixMainPosition={true}
                  animations={[opacity()]}
                  placeholder="Select Start Date"
                  weekDays={["S", "M", "T", "W", "T", "F", "S"]}
                  scrollSensitive={false}
                  hideOnScroll={false}
                />
              </div>
              <div>
                <DatePicker
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    borderRadius: "8px",
                    padding: "0.775rem 1rem",
                    fontSize: "1.1rem",
                    fontWeight: "500",
                    lineHeight: "1.5",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #f9f9f9",
                    color: "#5e6278",
                    transition: "color 0.2s ease",
                    height: "auto"
                  }}
                  containerStyle={{
                    width: "100%"
                  }}
                  className="rmdp-mobile custom-calendar"
                  arrow={false}
                  value={endDate}
                  onChange={(val) => {
                    setEndDate(val);
                  }}
                  minDate={dayjs(startDate).toDate()}
                  format="dddd MMM DD,YYYY"
                  fixMainPosition={true}
                  animations={[opacity()]}
                  placeholder="Select End Date"
                  weekDays={["S", "M", "T", "W", "T", "F", "S"]}
                  scrollSensitive={false}
                  hideOnScroll={false}
                />
              </div>
            </>
        }
        </div>
        <button
          type="button"
          className="btn btn-success"
          onClick={handleExport}
        >
        Export
        </button>
      </div>
      <h6 style={{ color: '#7e8299', textAlign: 'right' }}>Total: {clubCashData?.total || 0} </h6>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map(column => (
                <th
                  key={column.title}
                  className={column.className}
                  style={{ minWidth: column.width }}
                >
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold'>
            {clubCashData?.data?.length > 0 && (
              clubCashData?.data.map(row => (
                <tr key={row.arrear_id}>
                  <td style={{ minWidth: headers[0].width }}>
                    <Link to={`/users/${row?.tm_uid}`}>
                      {row.tm_name || '-'}
                    </Link>
                  </td>
                  <td style={{ minWidth: headers[1].width }}>
                    <Link to={`/users/${row?.tm_uid}`}>
                      {row.tm_public_id || '-'}
                    </Link>
                  </td>
                  <td style={{ minWidth: headers[2].width }}>
                    <Link to={`/bookings?search_type=reservation_code&search=${row.reservation_code}`}>
                      {row.reservation_code || '-'}
                    </Link>
                  </td>
                  <td style={{ minWidth: headers[3].width }}>{dayjs(row.date_of_earning).format('YYYY-MM-DD')}</td>
                  <td style={{ minWidth: headers[4].width, color: row.money_spent <= 0 ? '#ed2626' : '#2ecc71' }}>{formatPrice(row.money_spent || 0) || '$0'}</td>
                  <td style={{ minWidth: headers[5].width, color: row.cash_earned <= 0 ? '#ed2626' : '#2ecc71' }}>{formatPrice(row.cash_earned) || '$0'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {clubCashData?.data && !clubCashData?.data?.length > 0 &&
          <div className='d-flex text-center text-gray-600 fw-bolder fs-6 w-100 align-content-center justify-content-center mt-10'>
            No matching records found
          </div>
        }
      </div>
      <Pagination
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageSizeOptions={[50, 100, 200, 500]}
        total={clubCashData?.total || 0}
      />
      {isLoading && <UsersListLoading />}
    </KTCardBody>
  );
};
